import { render, staticRenderFns } from "./ManuscriptDeleteConfirm.vue?vue&type=template&id=dd35909e&scoped=true"
import script from "./ManuscriptDeleteConfirm.vue?vue&type=script&lang=ts"
export * from "./ManuscriptDeleteConfirm.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptDeleteConfirm.vue?vue&type=style&index=0&id=dd35909e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd35909e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd35909e')) {
      api.createRecord('dd35909e', component.options)
    } else {
      api.reload('dd35909e', component.options)
    }
    module.hot.accept("./ManuscriptDeleteConfirm.vue?vue&type=template&id=dd35909e&scoped=true", function () {
      api.rerender('dd35909e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/novel/ManuscriptDeleteConfirm.vue"
export default component.exports